<template>
  <RouterView
    :style="{
      '--inner-height': innerHeight
    }" />
</template>

<script>
export default {
  data () {
    this.innerHeight = `${window.innerHeight}px`
    return {}
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue